import React from 'react';
import { useTranslation } from 'react-i18next';

const Step = ({ number, title, description, isLast }) => (
  <div className="flex flex-col items-center text-center relative">
    <div className="bg-brand text-white rounded-full w-16 h-16 flex items-center justify-center text-xl font-bold mb-4 relative z-10">
      {number}
    </div>
    {!isLast && (
      <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gray-700 transform translate-x-8 z-0"></div>
    )}
    <h3 className="text-xl font-semibold text-white mb-3">{title}</h3>
    <p className="text-gray-300 max-w-xs">{description}</p>
  </div>
);

const VenuesHowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: 1,
      title: t('venues.how.step1.title'),
      description: t('venues.how.step1.description')
    },
    {
      number: 2,
      title: t('venues.how.step2.title'),
      description: t('venues.how.step2.description')
    },
    {
      number: 3,
      title: t('venues.how.step3.title'),
      description: t('venues.how.step3.description')
    }
  ];

  return (
    <section id="how-it-works" className="bg-gray-800 py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('venues.how.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('venues.how.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {steps.map((step, index) => (
            <Step
              key={index}
              {...step}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VenuesHowItWorks;
